"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProductSpecsFullImage;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _paragraph = _interopRequireDefault(require("@site/pattern-library-core/paragraph"));
var _image = require("@site/pattern-library-core/image");
const RowImageContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "RowImageContainer",
  class: "pl-rngfb7e"
});
const SharedFigcaption = /*#__PURE__*/(0, _react2.styled)(_paragraph.default)({
  name: "SharedFigcaption",
  class: "pl-srokbos"
});
const DisplayScreenSmall = /*#__PURE__*/(0, _react2.styled)(SharedFigcaption)({
  name: "DisplayScreenSmall",
  class: "pl-d2xjc7o"
});
const DisplayScreen = /*#__PURE__*/(0, _react2.styled)(SharedFigcaption)({
  name: "DisplayScreen",
  class: "pl-d1838cp6"
});
const DeviceLength = /*#__PURE__*/(0, _react2.styled)(SharedFigcaption)({
  name: "DeviceLength",
  class: "pl-dkd59u0"
});
const DeviceWidth = /*#__PURE__*/(0, _react2.styled)(SharedFigcaption)({
  name: "DeviceWidth",
  class: "pl-d142aeft"
});
const DeviceHeight = /*#__PURE__*/(0, _react2.styled)(SharedFigcaption)({
  name: "DeviceHeight",
  class: "pl-dhctrun"
});

/**
 * ProductSpecsFullImage Section.
 *
 * @param {Object} props React props
 * @param {String} props.landscapeImage Mobile < Set Image
 * @param {String} props.portraitImage Mobile > Set Image
 * @param {String} props.altText Image Alt Text for both images
 * @param {String} props.dataLayout Layout for rendering Figcaptions Poisitions
 * @param {String} props.displayScreenText Main Screen Dimensions
 * @param {String} props.displayScreenSmallText Secondary Screen Dimensions
 * @param {String} props.deviceLenghtText Length of device
 * @param {String} props.deviceHeightText Height of device
 * @param {String} props.deviceWidthText Width of device
 * @returns {React.ReactElement} Row Full Image Component
 * @public
 */

function ProductSpecsFullImage({
  landscapeImage,
  portraitImage,
  displayScreenText,
  displayScreenSmallText,
  deviceLenghtText,
  deviceHeightText,
  deviceWidthText,
  dataLayout,
  altText
}) {
  if (!landscapeImage && !portraitImage) return null;
  return /*#__PURE__*/_react.default.createElement(RowImageContainer, {
    "data-cy": "row-image"
  }, displayScreenText && /*#__PURE__*/_react.default.createElement(DisplayScreen, {
    "data-layout": dataLayout,
    text: displayScreenText
  }), displayScreenSmallText && /*#__PURE__*/_react.default.createElement(DisplayScreenSmall, {
    "data-layout": dataLayout,
    text: displayScreenSmallText
  }), deviceLenghtText && /*#__PURE__*/_react.default.createElement(DeviceLength, {
    "data-layout": dataLayout,
    text: deviceLenghtText
  }), deviceWidthText && /*#__PURE__*/_react.default.createElement(DeviceWidth, {
    "data-layout": dataLayout,
    text: deviceWidthText
  }), deviceHeightText && /*#__PURE__*/_react.default.createElement(DeviceHeight, {
    "data-layout": dataLayout,
    text: deviceHeightText
  }), /*#__PURE__*/_react.default.createElement(_image.LazyPicture, {
    defaultSrc: portraitImage,
    defaultAltText: altText
  }, /*#__PURE__*/_react.default.createElement("source", {
    srcSet: portraitImage,
    media: `${_patternLibraryUtils.deviceMax.mobileLg}`
  }), /*#__PURE__*/_react.default.createElement("source", {
    srcSet: landscapeImage,
    media: `${_patternLibraryUtils.device.tablet}`
  })));
}
ProductSpecsFullImage.propTypes = {
  landscapeImage: _propTypes.default.string,
  portraitImage: _propTypes.default.string,
  altText: _propTypes.default.string,
  displayScreenText: _propTypes.default.string,
  displayScreenSmallText: _propTypes.default.string,
  deviceLenghtText: _propTypes.default.string,
  deviceHeightText: _propTypes.default.string,
  deviceWidthText: _propTypes.default.string,
  dataLayout: _propTypes.default.oneOf(['smart-terminal', 'card-reader'])
};